<template>
  <v-row class="my-0">
    <v-col cols="12">
      <v-checkbox
        dense
        hide-details
        class="ma-0 pa-0"
        :input-value="includeTime"
        :disabled="disabled"
        :label="$t('checklist.date.include_time')"
        @change="handleInput({ includeTime: $event })"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DateTimeConfig',

  props: {
    includeTime: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('change', value)
    },
  },
}
</script>
